function ProgramSkeleton() {
    return (
        <div className="program__skeleton">
            <div style={{ display: 'flex', justifyContent: 'center', gap: 'var(--space-2)' }}>
                {[1, 2, 3].map(i => (
                    <div key={i} className="program__skeleton-bar" />
                ))}
            </div>

            <div style={{ display: 'flex', justifyContent: 'center', gap: 'var(--space-2)' }}>
                {[1, 2].map(i => (
                    <div key={i} className="program__skeleton-bar" />
                ))}
            </div>

            <div className="program__skeleton-grid">
                <div className="program__skeleton-timeline" style={{ gap: '16px' }}>
                    {Array.from({ length: 5 }).map((_, i) => (
                        <div
                            key={i}
                            className="program__skeleton-bar"
                            style={{ width: '80px', height: '60px' }}
                        />
                    ))}
                </div>
                {[1, 2].map(i => (
                    <div key={i} className="program__skeleton-column">
                        {Array.from({ length: 5 }).map((_, j) => (
                            <div key={j} className="program__skeleton-event" />
                        ))}
                    </div>
                ))}
            </div>
        </div>
    );
}
export default ProgramSkeleton;
